import { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal as ModalBs } from 'reactstrap';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  toggle: () => any;
  value: string;
  onSubmit: (txt: string) => any;
};

const Modal = styled(ModalBs)`
  .modal-content {
    width: 100%;
    padding: 1.5rem 1rem;
    align-items: center;
    .wrapper {
      margin-bottom: 1rem;
      text-align: center;
      img {
        width: 100%;
      }
    }
  }
  @media (min-width: 576px) {
    &.modal-dialog {
      max-width: 450px;
    }
  }
`;

const ModalOtherBrandInput = ({ isOpen, toggle, value, onSubmit }: Props) => {
  const [text, setText] = useState('');
  useEffect(() => {
    if (isOpen) setText(value);
  }, [isOpen]);

  return (
    <Modal className="other-brand-modal" isOpen={isOpen} toggle={toggle}>
      <p className={'title'}>Other Brand</p>
      <div className={'form-container'}>
        <input
          type={'text'}
          onChange={(e) => setText(e.target.value)}
          value={text}
          placeholder="Enter The Brand Name Here"
          className={'input-form'}
        />
      </div>
      <div
        className={`button-confirm ${text.length < 1 ? 'disabled' : ''}`}
        onClick={() => {
          if (text.length > 0) onSubmit(text);
        }}
      >
        <p>Submit</p>
      </div>
      <div className={'close-button'} onClick={toggle}>
        <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
          <div>
            <GrClose />
          </div>
        </IconContext.Provider>
      </div>
    </Modal>
  );
};

export default ModalOtherBrandInput;
